import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcListComponent } from './fc-list.component';

const components = [FcListComponent];
@NgModule({
    imports: [CommonModule],
    declarations: components,
    exports: components
})
export class FcListModule {}
